module.exports = __webpack_public_path__ + "img/pngegg-300x188.545dcb12.png";